import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20stage%20backdrop%20with%20flowing%20red%20and%20gold%20silk%20curtains%2C%20dynamic%20motion%20blur%20effect%2C%20deep%20charcoal%20background%20with%20vibrant%20crimson%20and%20amber%20color%20streaks%2C%20mysterious%20and%20luxurious%20atmosphere%2C%20cinematic%20lighting%20with%20dramatic%20contrast%2C%20elegant%20theater%20stage%20aesthetic%2C%20no%20people%2C%20abstract%20artistic%20composition&width=1920&height=1080&seq=home-hero-bg-01&orientation=landscape"
          alt="17黑料网 - 网红黑料追踪"
          title="17黑料网官网入口 - 17黑料吃瓜与17吃瓜黑料"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full flex flex-col items-center text-center px-4">
        <p className="font-label text-xs md:text-sm tracking-[0.3em] uppercase text-accent-400 mb-4 md:mb-6 animate-fade-in">
          全网独家 · 每日更新
        </p>
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-black text-white mb-4 md:mb-5 tracking-tight leading-tight">
          17黑料网
        </h1>
        <p className="font-heading text-lg md:text-2xl italic text-white/80 mb-4 md:mb-6 font-light">
          全网独家吃瓜追踪
        </p>
        <p className="text-sm md:text-base text-white/60 max-w-xl mb-8 md:mb-10 leading-relaxed">
          覆盖17黑料吃瓜、17吃瓜黑料等核心内容，每日追踪网红塌房、黑料视频、争议事件
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/wanghong-tafang"
            className="px-8 py-3 md:px-10 md:py-3.5 bg-primary-500 hover:bg-primary-600 text-white rounded-full font-label font-semibold text-sm md:text-base transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            立即吃瓜
          </Link>
          <Link
            to="/category/chigua-baoliao"
            className="px-8 py-3 md:px-10 md:py-3.5 border border-white/30 hover:border-white/60 text-white/80 hover:text-white rounded-full font-label text-sm md:text-base transition-all duration-300 whitespace-nowrap"
          >
            最新爆料
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white/40 text-xl"></i>
      </div>
    </section>
  );
}